<template>
  <div>
    <div>
      <Titulo :titulo="'Informes - ' + routeName" />
    </div>
    <!-- coger el parametro que se envio por la ruta -->
    <!-- {{$route.params.id}} -->
    <div class="margin-informes">
      <!-- <h4 class="color-secundary">Base garantizados</h4> -->
      <p class="mb-5 text-justify">
        <!-- <b>Icono circular:</b> a través de esta opcíón, se puede descargar la base de garantizados al último corte contable.
        <br />-->
        <b>Filtro:</b> a través de esta opcíón, se puede descargar la base de
        operaciones con productos FGA Fondo de Garantías, en un periodo de
        tiempo determinado.
      </p>

      <!--
        @props
            data: Array,            required: true
            pagination: boolean,    required: false
            perPage: Number,        required: false
            SetectFiltro: Array     required: false
            filtro: boolean         required: false
      -->
      <table-component
        :data="TablaGarantizado.datos"
        @click-generar="generar"
        @click-event="clickEvent"
        filtro
        :dataLength="dataLength"
        :showExportToExcel="true"
        :showFilterDates="true"
        :showButtonBuscar="false"
        showButtonGenerar
        :showFilterEstadoGarantia="true"
        :EstadoGarantia="EstadoGarantia"
        :Modelos="Modelos"
        :TipoArchivo="TipoArchivo"
        showFilterModelos
        showFilterTipoDoc
        :showFilterConvenios="true"
        :Convenios="convenios"
      >

        <table-column
          slot="label"
          :label="'Archivo'"
          v-bind:value="'nombre'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Fecha de creación'"
          v-bind:value="'created_at'"
          :customClass="'text-center'">
        <template #cell(created_at)="data">
          <span v-html="$options.filters.numberFormat(this.$moment(data.item.created_at).format('YYYY-MM-DD'))"></span>
        </template>
        </table-column>
        <table-column
          slot="label"
          :label="'Estado'"
          v-bind:value="'estado'"
          :customClass="'text-center'"
        ></table-column>
        <table-column slot="label" :label="'Descargar archivo'" :icon="'fa'">
          <template
            slot="icon"
            :icon="'fa fa-download'"
            :class="'btn btn-sm btn-info'"
            :slug="'Descargar'"
            :tooltip="'Descargar archivo'"
            :customActive="buttonsActives"
            :loading="false"
          ></template>
        </table-column>
      </table-component>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import SelectNovedad from "@/data/SelectQueEsNovedad.json";
import SelectTipoNovedad from "@/data/SelectTipoNovedad.json";
import XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  name: "SubirInformes",
  data() {
    return {
      SelectNovedad: SelectNovedad,
      SelectTipoNovedad: SelectTipoNovedad,
      fecha_inicio: this.$moment().startOf("month").format("YYYY-MM-DD"),
      fecha_fin: this.$moment().format("YYYY-MM-DD"),
      selectQueEsNovedad: "",
      selectTipoNovedad: "",
      EstadoGarantia: [
        { value: null, text: "Estado",disabled: true },
        { value: "VIGENTE", text: "Vigente" },
        { value: "CANCELADA", text: "Cancelada" },
        { value: "EXTINGUIDA", text: "Extinguida" },
        { value: "PAGADA", text: "Pagada" },
      ],
      Modelos:[
        { value: null, text: "Modelo",disabled: true },
        { value: "1", text: "Respaldo FGA" },
        { value: "2", text: "Cobertuta Integral" }
      ],
      TipoArchivo:[
        { value: null, text: "CSV"},
        { value: 'xlsx', text: "Excel" }
      ],
      estadoGarantiaSelected: null,
      modelo:null,
      convenio: null,
      buttonsActives: ["finalizado", "rechazado", "pendiente de revision"],
    };
  },
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    TableComponent: () => import("@/components/table/TableComponent"),
    TableColumn: () => import("@/components/table/TableColumn"),
  },
  computed: {
    ...mapGetters({
      TablaGarantizado: "pages/tablaGarantizado",
      TablaVerProducto: "pages/TablaVerProducto",
      reloaded: "pages/reload",
      loading: "loading",
      user: "user/user",

    }),
    convenios() {
      let data = this.$store.getters["pages/convenios"].map((convenio) => {
        return { value: convenio.id, text: convenio.nombre_convenio };
      });
      data.unshift({ value: null, text: "Código", disabled: true });
      return data;
    },
    dataLength() {
      return this.$store.getters["pages/total"];
    },
    data() {
      return this.$store.getters["pages/dataInformes"];
    },
    total() {
      return this.$store.getters["pages/total"];
    },
    saveToExcel() {},
    routeName() {
      return this.$router.currentRoute.name;
    },
  },
  methods: {
    generar(event) {
      if (!event.filterTipoArchivoSelected) {
        event.filterTipoArchivoSelected = 'csv'
      }
        this.$store.getters.api.post("portal/informes/base_garantizados", {
          fecha_inicio: event.fecha_inicio,
          fecha_fin: event.fecha_fin,
          estado_garantia: event.filterEstadoGarantiaSelected,
          extension: event.filterTipoArchivoSelected,
          modelo: event.filterModelosSelected,
          convenio: event.convenio,
      }).then(()=> {
      })
    },
    async clickEvent(data, slug) {
      switch (slug) {
        case "Descargar":
          this.$toasted.show("Por favor espere mientras descargamos el archivo", {
            theme: "toasted-primary",
            position: "top-center",
            duration: 3000,
          });

          this.$store.commit("SET_LOADING", true);

          let descarga = new Promise((res, rej) => {
            this.$store.getters.api.post("/portal/informes/base_garantizados/descargar", {
              id: data.id
            },
            {
              responseType: "arraybuffer"
            })
            .then((response) => {
              res(response.data)
            })
            .catch((error) => {
              rej(error);
            });
          });

          descarga.then((datos) => {
            saveAs(
              new Blob([datos]),
              data.nombre
            );
          })
          .catch(() => {
            let toast = this.$toasted.show(
              "Error intentando descargar el archivo",{
                  theme: "toasted-primary",
                  position: "bottom-right",
                  duration: 5000,
                }
            );
          })
          .then(() => {
            this.$store.commit("SET_LOADING", false);
          })


          break;
      }
    },
    loadData() {
      this.$store.dispatch("pages/fetchGarantizado", {
        endpoint: "portal/informes/base_garantizados"
      });
    },
  },
  mounted() {
    this.loadData();
    this.$store.dispatch("pages/fetchConvenios", {
      endpoint: "portal/informes/convenio",
    });
    window.Echo.channel('base-garantizados'+ this.user.sig_banco_id).listen(
      "BaseGarantizadosEvent",
      (e) => {
        const index = this.TablaGarantizado.datos.findIndex(item => item.id === e.sigArchivo.id);
        if (index !== -1) {
            this.TablaGarantizado.datos.splice(index, 1, e.sigArchivo);
        } else {

            if (this.TablaGarantizado.datos.length >= 5) {
                this.TablaGarantizado.datos.pop()
            }

            let datos = [e.sigArchivo].concat(this.tablaGarantizado.datos)
            this.TablaGarantizado.datos = datos
        }
      }
    )
  },
};
</script>